'use client';

import React from 'react';
import { cn } from '@/lib/cn';

/* ================================================================
   Delos Tabs — 顶部导航标签 + 底部指示线
   ================================================================ */

interface Tab {
  key: string;
  label: string;
  icon?: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  activeKey: string;
  onChange: (key: string) => void;
  size?: 'sm' | 'md';
  className?: string;
}

export function Tabs({ tabs, activeKey, onChange, size = 'md', className }: TabsProps) {
  return (
    <div className={cn('flex min-w-0 items-center gap-1 overflow-x-auto', className)}>
      {tabs.map((tab) => {
        const active = tab.key === activeKey;
        return (
          <button
            key={tab.key}
            type="button"
            data-studio-control
            aria-pressed={active}
            onClick={() => onChange(tab.key)}
            className={cn(
              'relative flex shrink-0 items-center gap-1.5 whitespace-nowrap px-4 rounded-full transition-colors [@media(pointer:coarse)]:min-h-11',
              size === 'sm' ? 'h-8 text-xs' : 'h-9 text-sm',
              'font-medium',
              active
                ? 'bg-accent-soft text-[#176B89]'
                : 'text-hr-text-secondary hover:text-hr-text-primary hover:bg-surface-hover'
            )}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
